import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../useAuth";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { user } = useAuth();

  // Prevent search engines from indexing authenticated pages
  useEffect(() => {
    const existing = document.querySelector('meta[name="robots"]');
    if (existing) {
      existing.setAttribute("content", "noindex, nofollow");
    } else {
      const meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      meta.setAttribute("content", "noindex, nofollow");
      document.head.appendChild(meta);
    }
    return () => {
      // Restore public indexing when navigating away from private routes
      const meta = document.querySelector('meta[name="robots"]');
      if (meta) meta.setAttribute("content", "index, follow");
    };
  }, []);

  return user ? <>{children}</> : <Navigate to="/login" />;
};

export default PrivateRoute;
